
import filters from "@/filters";
import { Component, Vue } from "vue-property-decorator";
import AppLayout from "@/layouts/AppLayout.vue";

@Component({
  components: {
    AppLayout,
  },
  filters,
})
export default class GuestPayment extends Vue {
  private get isRejected() {
    return this.$route.params?.status === "failure";
  }
  private get isApproved() {
    return this.$route.params?.status === "success";
  }
}
